import { createRouter, createWebHashHistory } from 'vue-router';
import TemplateGenerator from '../views/TemplateGenerator.vue';
import TemplateConfig from '../views/TemplateConfig.vue';
import Variables from '../views/Variables.vue';
import Guide from '../views/Guide.vue';
import Generations from '../views/Generations.vue';
import Admin from '../views/Admin.vue';
import TenantDetail from '../views/TenantDetail.vue';
import MyCompany from '../views/MyCompany.vue';
import MyTemplates from '../views/MyTemplates.vue';
import Welcome from '../views/Welcome.vue';
import Pricing from '../views/Pricing.vue';
import Changelog from '../views/Changelog.vue';
import PrivacyPolicy from '../views/PrivacyPolicy.vue';
import Terms from '../views/Terms.vue';
import { useTenantStore } from '../stores/tenant';
import { tenantApi } from '../services/api';

const routes = [
  {
    path: '/',
    name: 'Generate',
    component: TemplateGenerator,
    meta: {
      title: 'generate'
    }
  },
  {
    path: '/template-setup',
    name: 'TemplateSetup',
    component: TemplateConfig,
    meta: {
      title: 'templateSetup'
    }
  },
  {
    path: '/variables',
    name: 'Variables',
    component: Variables,
    meta: {
      title: 'variables'
    }
  },
  {
    path: '/generations',
    name: 'Generations',
    component: Generations,
    meta: {
      title: 'generations'
    }
  },
  {
    path: '/guide',
    name: 'Guide',
    component: Guide,
    meta: {
      title: 'guide'
    }
  },
  {
    path: '/admin',
    name: 'Admin',
    component: Admin,
    meta: {
      title: 'admin'
    }
  },
  {
    path: '/admin/tenants/:tenantKey',
    name: 'TenantDetail',
    component: TenantDetail,
    meta: {
      title: 'tenantDetail'
    }
  },
  {
    path: '/my-company',
    name: 'MyCompany',
    component: MyCompany,
    meta: {
      title: 'myCompany'
    }
  },
  {
    path: '/my-templates',
    name: 'MyTemplates',
    component: MyTemplates,
    meta: {
      title: 'myTemplates'
    }
  },
  {
    path: '/welcome',
    name: 'Welcome',
    component: Welcome,
    meta: {
      title: 'welcome'
    }
  },
  {
    path: '/pricing',
    name: 'Pricing',
    component: Pricing,
    meta: {
      title: 'pricing'
    }
  },
  {
    path: '/changelog',
    name: 'Changelog',
    component: Changelog,
    meta: {
      title: 'changelog'
    }
  },
  {
    path: '/privacy',
    name: 'Privacy',
    component: PrivacyPolicy,
    meta: {
      title: 'privacy'
    }
  },
  {
    path: '/terms',
    name: 'Terms',
    component: Terms,
    meta: {
      title: 'terms'
    }
  }
];

const router = createRouter({
  history: createWebHashHistory(),
  routes
});

// Navigation guard: Redirect to My Company if personal base token is not set
router.beforeEach(async (to, _from, next) => {
  // Skip guard for admin routes, My Company page, My Templates page, and public pages
  const publicPaths = ['/admin', '/my-company', '/my-templates', '/welcome', '/pricing', '/changelog', '/privacy', '/terms']
  if (publicPaths.some(path => to.path.startsWith(path) || to.path === path)) {
    next();
    return;
  }

  const tenantStore = useTenantStore();

  // If we haven't loaded tenant/base info yet, load it now
  if (!tenantStore.isLoaded) {
    try {
      const { tenant, base } = await tenantApi.getTenantInfo();
      tenantStore.setTenantAndBase(tenant, base);
    } catch (error) {
      console.error('Failed to load tenant info:', error);
      // If we can't load tenant info, let them through (will fail elsewhere)
      next();
      return;
    }
  }

  // If personal base token is not set, redirect to My Company
  if (!tenantStore.hasPersonalBaseToken) {
    next('/my-company');
    return;
  }

  // All checks passed, proceed
  next();
});

export default router;
